export default __webpack_public_path__ + "static/media/gs-3.3f72bf98.png";